module.exports = __webpack_public_path__ + "img/maintenance_3.06b2604b.svg";